import { render, staticRenderFns } from "./tables.vue?vue&type=template&id=680c555f&scoped=true"
import script from "./tables.vue?vue&type=script&lang=js"
export * from "./tables.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "680c555f",
  null
  
)

export default component.exports